var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "header" }, [
    _c(
      "div",
      { staticClass: "logo" },
      [
        _c("router-link", { staticClass: "logo-link", attrs: { to: "/" } }, [
          _c("img", {
            attrs: {
              src: "/images/logo.png",
              alt: "北京西宝电子技术有限责任公司",
            },
          }),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("span", { staticClass: "menuBtn" }),
    _vm._v(" "),
    _c("div", { staticClass: "hdr" }, [
      _c("div", { staticClass: "nav" }, [
        _c("ul", [
          _c(
            "li",
            {
              staticClass: "i1 mouseenter mouseleave",
              class: { on: _vm.isActive("/") },
            },
            [
              _c("router-link", { staticClass: "v1", attrs: { to: "/" } }, [
                _vm._v("首页"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "i2 mouseenter mouseleave",
              class: { on: _vm.isAboutActive },
            },
            [
              _c(
                "router-link",
                { staticClass: "v1", attrs: { to: "/about" } },
                [_vm._v("关于我们")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sub sub-1" }, [
                _c("dl", [
                  _c(
                    "dd",
                    [
                      _c("router-link", { attrs: { to: "/about#company" } }, [
                        _vm._v("公司简介"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    [
                      _c("router-link", { attrs: { to: "/about#honors" } }, [
                        _vm._v("公司荣誉"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "i3 mouseenter mouseleave",
              class: { on: _vm.isProductActive },
            },
            [
              _c(
                "router-link",
                { staticClass: "v1", attrs: { to: "/product-center?id=308" } },
                [_vm._v("产品中心")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "i3 mouseenter mouseleave",
              class: { on: _vm.isAppActive },
            },
            [
              _c(
                "router-link",
                { staticClass: "v1", attrs: { to: "/app-center" } },
                [_vm._v("应用中心")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "i4 mouseenter mouseleave",
              class: { on: _vm.isNewsActive },
            },
            [
              _c("router-link", { staticClass: "v1", attrs: { to: "/news" } }, [
                _vm._v("新闻资讯"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sub sub-1" }, [
                _c("dl", [
                  _c(
                    "dd",
                    [
                      _c("router-link", { attrs: { to: "/news#company" } }, [
                        _vm._v("公司新闻"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/news#new-product" } },
                        [_vm._v("最新产品")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "so" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.performSearch.apply(null, arguments)
              },
            },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchKeyword,
                  expression: "searchKeyword",
                },
              ],
              staticClass: "inp",
              attrs: { type: "text", placeholder: "请输入搜索内容" },
              domProps: { value: _vm.searchKeyword },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchKeyword = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.performSearch.apply(null, arguments)
                },
              },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }